import { Component, OnInit } from '@angular/core';
import "./skisporet.component.scss";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Component({
  selector: 'skisporet-element',  
  templateUrl: './skisporet.component.html'
})

export class SkisporetComponent implements OnInit {

  constructor(private http: HttpClient) { }

  ngOnInit(): void {

  }  

}